var swiper = new Swiper(".logo-list-slider", {
    spaceBetween: 20,
  slidesPerView: 3,
    loop: true,
   breakpoints: {
          1440:{
              slidesPerView: 6,
              spaceBetween: 20
          },
          1024: {
              slidesPerView: 5,
              spaceBetween: 10
          },
          768: {
              slidesPerView: 4,
              spaceBetween: 10
          },
          640: {
              slidesPerView: 3,
              spaceBetween: 10
          }
      },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
  });